import { useLocation } from 'react-router'

import { getPageKeyByPath, pages } from '~/app/routes'
import env from '~/env'
import { useStore } from '~/store/store'
import { useDepartments } from '~/storm'

import { getBrowserInfo, getDepartmentLabel, getFeatureFlagsSnapshot } from './utils'

export type BugReportFeatureFlagsSnapshot = Record<string, boolean | string>

export type UserFeedbackMetadataProps = {
    category: UserSupportFormCategory
    fullName: string
    username: string
    currentUrl: string
    heroVersion: { tag: string; sha: string }
    browserVersion: string
    departmentLabel: string
    pageKey: string
    pageTitle: string
    featureFlags: BugReportFeatureFlagsSnapshot
}

export type UserSupportFormCategory = 'bug report' | 'user support' | 'suggestion'

export function useUserSupportMetadata(category: UserSupportFormCategory): UserFeedbackMetadataProps {
    const { pathname } = useLocation()
    const { display_name, username } = useStore(state => state.user)
    const departmentKey = useStore(state => state.appFilters.departmentKey)
    const selectedDepartments = useDepartments({ where: departmentKey === 'all' ? undefined : { id: departmentKey } })
    const departments = selectedDepartments.map(d => ({ id: d.id, name: d.name }))

    const pageKey = getPageKeyByPath(pathname)
    const pageTitle = pageKey !== undefined ? pages[pageKey].title : undefined

    return {
        category,
        fullName: display_name ?? '–',
        username: username ?? '–',
        currentUrl: typeof window !== 'undefined' ? window.location.href : '',
        heroVersion: {
            tag: env.VITE_GIT_TAG ?? '',
            sha: env.VITE_GIT_SHA ?? '',
        },
        browserVersion: getBrowserInfo(),
        departmentLabel: getDepartmentLabel(departmentKey, departments),
        pageKey: pageKey ?? '',
        pageTitle: pageTitle ?? '',
        featureFlags: getFeatureFlagsSnapshot(),
    }
}
